import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { CustomView } from "./SequenceViews/CustomView/CustomView";
export class RcsbFvCustomSequence extends React.Component {
    render() {
        const config = this.props.config;
        return (_jsx(CustomView, Object.assign({}, config, { structureViewer: this.props.structureViewer, componentId: this.props.componentId, stateManager: this.props.stateManager, title: this.props.title, subtitle: this.props.subtitle, unmount: this.props.unmount })));
    }
}
